import {gsap} from 'gsap';
import {setElementAnimateOffsetResponsive, getElementAnimateDelay, inViewPointerMobile} from '../../../libs/helper';
import AnimationHelper from "../../../libs/animation-helper";

class AnimationFade {

    constructor(el, options = {}) {
        this.DOM = {el};
        if (!inViewPointerMobile(this.DOM.el) && options.handleScrolling) return;
        this.options = {...options};
        this.addAnimationType();
    }

    addAnimationType() {

        this.DOM.el.classList.add('animation--fade');
        let optionsSwitch;
        switch (this.options.type) {
            case 'fade_tran':
                optionsSwitch = {
                    _from: {
                        opacity: 0,
                        y: 50
                    },
                    _to: {
                        keyframes: [
                            {
                                opacity: 1,
                                ease: 'power3.inOut',
                                duration: .6,
                            },
                            {
                                y: 0,
                                ease: 'power3.out',
                                duration: .8,
                                delay: -.6
                            }
                        ],
                        delay: (this.options.delay || 0)
                    },
                    _out: {
                        opacity: 0,
                        y: -30,
                        ease: 'power3.inOut',
                        duration: .6,
                    }
                };

                break;
            default:
                optionsSwitch = {
                    _from: {
                        opacity: 0
                    },
                    _to: {
                        opacity: 1,
                        ease: 'power3.inOut',
                        duration: .8,
                        delay: this.options.delay || 0,
                        clearProps: "all"
                    },
                    _out: {
                        opacity: 0,
                        ease: 'power3.inOut',
                        duration: .6,
                    }
                };
                break;
        }

        this.options._from = Object.assign({}, optionsSwitch._from, this.options._from);
        this.options._to = Object.assign({}, optionsSwitch._to, this.options._to,);
        this.options._out = Object.assign({}, optionsSwitch._out, this.options._out);

        this.DOM.el.classList.remove('is-animation');

        if (this.options.handleScrolling) {
            this.animationHelper = new AnimationHelper({
                el: this.DOM.el,
                handleObServer: this.DOM.el.parentElement,
                animationIn: this.animationIn.bind(this),
                options: this.options
            });

        }
        gsap.set(this.DOM.el, this.options._from);
    }

    resetAnimation() {
        this.animationHelper && this.animationHelper.addObServer();
        gsap.set(this.DOM.el, this.options._from);
    }

    animationIn(delay = 0) {
        if (this.animationHelper) {
            delay += this.animationHelper.getDelayAnimation();
            this.animationHelper.removeHandleScrolling();
        }

        const optionTo = Object.assign({delay: 0}, this.options._to);
        optionTo.delay += delay;
        gsap.killTweensOf(this.DOM.el);
        gsap.fromTo(this.DOM.el, this.options._from, optionTo);

        setTimeout(() => {
            this.DOM.el.classList.add('is-animation-completed');
        }, (optionTo.delay + optionTo.duration) * 1000);
    }

    animationOut(delay = 0, onComplete = null) {
        this.options._out.delay = delay;
        gsap.killTweensOf(this.DOM.el);
        if (onComplete) this.options._out.onComplete = onComplete;
        gsap.to(this.DOM.el, this.options._out);
    }

    animationReset() {
        gsap.killTweensOf(this.DOM.el);
        gsap.set(this.DOM.el, this.options._from);
    }

    clearAnimation() {
        this.DOM.el.style = {};
    }
}

export default AnimationFade;